// extracted by mini-css-extract-plugin
export default {"product-price":"S54FS2","productPrice":"S54FS2","baseSavings":"IfTFvt","savingsSale":"b5MCm7","savings":"DzTOzc"};